<template>
  <b-modal
    no-close-on-esc
    no-close-on-backdrop
    ref="speechModal"
    @hide="$emit('close')"
    id="speech-modal"
    :visible="open"
    size="xl"
    :class="[isMinimized == 1 ? 'captureMin' : 'captureMax']"
  >
    <template #modal-header>
      <b-row align-h="between" class="head-container" style="width: 100%">
        <b-col md="10" align-self="center">
          <h5>
            {{ $t('visit.captureSpeech') }} - Lekarz {{ captureTitle }} :
            {{ new Date().toLocaleString() }}
          </h5>
        </b-col>
        <b-col md="2" align-self="center" class="text-right">
          <b-button
            variant="secondary"
            size="sm"
            :title="$t('visit.captureMinimize')"
            @click="minimizeCapture"
          >
            {{ $t('visit.captureMinimize') }}&nbsp;
            <font-awesome-icon icon="window-minimize"></font-awesome-icon>
          </b-button>
        </b-col>
      </b-row>
    </template>
    <div>
      <b-row>
        <b-col md="12">
          <p style="font-style: italic; text-align: center; margin: auto">
            {{ interimText }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5">
          <b-link
            v-if="zapisane.length && !sourceContent && !autozapisTimer"
            class="d-block mb-2 small"
            @click="przywrocZapisana"
            >Przywróć zapisaną rozmowę ({{ opisZapisanej }})</b-link
          >
          <b-card
            ref="scrollableDiv"
            class="voiceCapture"
            style="max-height: 50vh; overflow-y: auto; padding: 0; margin: 0"
          >
            <div
              ref="voiceSource"
              contenteditable="true"
              v-if="showSource"
              class="words editable-content"
              v-html="sourceContent"
            ></div>
            <div
              ref="voiceTimeline"
              class="words"
              v-if="showTimeline"
              v-html="timelineContent"
            ></div>
          </b-card>
          <b-button
            variant="secondary"
            class="mt-2"
            size="sm"
            @click="clearAll"
            >{{ $t('visit.captureClear') }}</b-button
          >
          <b-button
            variant="primary"
            class="mt-2 ml-2 float-right"
            size="sm"
            :disable1d="
              summaryStatus === 1 ||
              finalTranscript.length == 0
            "
            @click="handleSummarize"
            >{{ $t(summarizeLabel) }}
            {{ summaryStatus === 1 ? '...' : '' }}</b-button
          >
          <select
            v-model="promptId"
            @change="handlePromptChange"
            md="12"
            class="float-right mt-3 ml-2"
          >
            <option
              v-for="option in this.prompts"
              :key="option.sno"
              :value="option.sno"
            >
              {{ option.name }}
            </option>
          </select>
        </b-col>

        <b-col md="2" class="d-flex align-items-start justify-content-center">
          <b-row>
            <b-col md="12">
              <div
                class="mt-3 ml-3 pb-2 d-flex align-items-center justify-content-center"
              >
                <mic-capture-real-time-speech-matics
                  v-if="(telewizytaAktywna || selectedMicrophone != '') && vocabSettings.custom_list"
                  :key="componentKey"
                  ref="speechCapt"
                  :lang="lang_"
                  :vocabSettings="vocabSettings"
                  @transcriptionText="onTranscriptionText"
                  @sessionInitiated="onSessionInitiated"
                  @sessionInitiationError="onSessionInitiationError"
                  @sessionCompleted="onSessionCompleted"
                  :device-id="selectedMicrophone"
                  :external-stream="externalStream"
                ></mic-capture-real-time-speech-matics>
                <!-- zamiast wiecznego „Loading Settings." — powód i wyjście -->
                <div v-else class="text-center px-3">
                  <p v-if="mikrofonKomunikat" class="mb-2 text-danger">
                    {{ mikrofonKomunikat }}
                  </p>
                  <p v-else-if="!vocabSettings.custom_list" class="mb-2">
                    Wczytuję ustawienia transkrypcji…
                  </p>
                  <p v-else class="mb-2">Przygotowuję mikrofon…</p>
                  <b-button
                    v-if="mikrofonKomunikat"
                    size="sm"
                    variant="primary"
                    @click="zapewnijMikrofon(true)"
                  >
                    Spróbuj ponownie
                  </b-button>
                </div>
              </div>
              <div
                class="mt-2 d-flex align-items-center justify-content-center"
              >
                <select
                  :disabled="$refs?.speechCapt?.isRecording == true"
                  v-model="selectedMicrophone"
                  style="width: 50%; display: block"
                  class="m-2"
                >
                  <option
                    v-for="mic in microphones"
                    :key="mic.deviceId"
                    :value="mic.deviceId"
                  >
                    {{ mic.label }}
                  </option>
                </select>
                <select v-model="lang_">
                  <option :value="navAgentLang">{{ navAgentLang }}</option>
                  <option v-if="navAgentLang != 'pl-PL'" value="pl-PL">
                    Polski
                  </option>
                  <option v-if="navAgentLang != 'en-US'" value="en-US">
                    English(US)
                  </option>
                  <option value="fr-FR">French</option>
                </select>
              </div>

              <a v-if="audioUrl" :href="audioUrl" :download="audioFilename"
                >Download Audio {{ audioChunks.length }}</a
              >
              <p
                style="
                  font-style: italic;
                  text-align: center;
                  margin: auto;
                  color: red;
                "
              >
                <span v-if="$refs?.speechCapt?.totalAudioSize > 0"
                  >size :
                  {{
                    Math.ceil($refs?.speechCapt?.totalAudioSize / 1024).toFixed(
                      2
                    )
                  }}
                  KB |
                </span>
                {{ getProcessingStatus }}
              </p>
              <b-button
                variant="secondary"
                @click="minimizeCapture"
                class="primary mt-4 p-1"
                style="border: 1px solid #eee; text-align: center"
              >
                {{ $t('visit.captureMinimize') }}&nbsp;
                <font-awesome-icon
                  style="float: right; color: rgb(245, 239, 239)"
                  icon="window-minimize"
                ></font-awesome-icon>
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="5">
          <b-alert
            :show="!!summaryError"
            variant="warning"
            class="mb-2"
            dismissible
            @dismissed="summaryError = ''"
            >{{ summaryError }}</b-alert
          >
          <b-card
            class="voiceCapture"
            ref="scrollableDivFormatted"
            style="max-height: 50vh; overflow-y: auto; padding: 0; margin: 0"
          >
            <div
              ref="voiceFormatted"
              contenteditable="true"
              class="words editable-content highlight-text"
            ></div>
          </b-card>
          <b-button variant="success" class="mt-2 ml-2" size="sm" v-if="2 > 3"
            >Copy Content</b-button
          ><b-button
            @click="handleSave"
            variant="warning"
            class="mt-2 ml-2 float-right"
            size="sm"
            >{{ $t('visit.captureSave') }}</b-button
          >
        </b-col>
      </b-row>
    </div>
    <template #modal-footer>
      <b-row>
        <b-col class="text-right">
          <b-button
            @click="
              $bvModal.hide('speech-modal')
              $refs?.speechCapt?.stopRecording()
            "
            >{{ $t('close') }}</b-button
          >
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
// import MicCaptureRealTime from '../../../components/MicCaptureRealTime.vue'
import MicCaptureRealTimeSpeechMatics from '../../../components/MicCaptureRealTimeSpeechMatics.vue'
import aiServicesApi from '../../../services/aiServicesApi'
import { nanoid } from 'nanoid'

const uploadAudioChunk = async (chunkData, presignedUrl) => {
  try {
    const res = await fetch(presignedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'audio/wav'
        // 'Content-Range': `bytes ${chunkData.start}-${chunkData.end}/${chunkData.total}`
      },
      body: chunkData
    })

    if (res.ok) {
      // console.log('Chunk uploaded successfully.')
      return await res.json()
    } else {
      // console.error('Error uploading chunk:', res.statusText)
      return Promise.resolve({})
    }
  } catch (error) {
    // console.error('Error uploading chunk:', error)
  }
}

const port = process.env.VUE_APP_API_PORT || 3000
const baseURL =
  process.env.NODE_ENV === 'production' ? `` : `http://localhost:${port}`

export default {
  data() {
    return {
      recording: false,
      componentKey: 0,
      // telewizyta: nagrywanie bez wyboru mikrofonu; zostaje po rozłączeniu, żeby oddać tekst do podsumowania
      telewizytaAktywna: false,
      microphones: [],
      selectedMicrophone: null,
      audioChunks: [],
      audioUrl: null,
      mediaRecorder: null,
      finalTranscript: '',
      dataStream: {},
      isMinimized: 0,
      recordingStartedAt: null,
      /** komunikat dla lekarza, gdy mikrofon nie jest gotowy (pusto = wszystko gra) */
      mikrofonKomunikat: '',
      showModal: true,
      captureTitle: '',
      showSource: true,
      fullContent: [],
      showTimeline: false,
      transcription: [],
      timelines: [],
      sourceContent: '',
      timelineContent: '',
      interimText: '',
      prompts: [],
      vocabSettings: {},
      lang_: window.navigator.language,
      promptId: 1,
      summaryStatus: 0,
      progressStatus: 0,
      /** błąd podsumowania dla lekarza; tekst rozmowy (lewe pole) zostaje nietknięty */
      summaryError: '',
      /** transkrypcje tej wizyty zapisane w medapi (dziennik EHR, 30 dni) — do odzysku, gdy podsumowanie padło */
      zapisane: [],
      /** zapis w toku co 60 s w czasie nagrywania (łata na zamknięcie karty bez zatrzymania) */
      autozapisTimer: null,
      autozapisSesja: null,
      autozapisOstatni: '',
      audioFilename: ''
      // 0 - default, 1- submitted 3-processed
    }
  },
  components: { MicCaptureRealTimeSpeechMatics },
  async mounted() {
    this.captureTitle = await this.getCaptureTitle()
    this.prompts = await this.getSummaryPrompts()
    aiServicesApi.getSavedTranscripts(this.$route.params.visit).then((lista) => { this.zapisane = lista })
    this.audioFilename =
      this.captureTitle +
      '_' +
      new Date().toLocaleString().replace(/\//g, '').replace(/:/g, '_')
    this.getMicrophones()
  },
  beforeDestroy() {
    this.zatrzymajAutozapis()
  },
  computed: {
    opisZapisanej() {
      const z = this.zapisane[0]
      if (!z) return ''
      const kiedy = String(z.kiedy || '')
      const dzis = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Warsaw' }).format(new Date())
      const godzina = kiedy.slice(11, 16)
      return (kiedy.slice(0, 10) === dzis ? 'dziś ' + godzina : kiedy.slice(8, 10) + '.' + kiedy.slice(5, 7) + ' ' + godzina) +
        ', ' + Number(z.znaki || 0).toLocaleString('pl-PL') + ' znaków'
    },
    getProcessingStatus() {
      const statuses = [
        '',
        'preparing to upload audio',
        'audio uploaded',
        'processing audio',
        'audio Processed',
        'extracting summary',
        'summary completed'
      ]
      return this.progressStatus === 0
        ? ''
        : statuses[this.progressStatus] + '...'
    },
    navAgentLang() {
      return window.navigator.language
    },
    summarizeLabel() {
      const labelStatus = [
        'visit.captureSummarize',
        'visit.captureSummarizing',
        'visit.captureSummarize'
      ]
      return labelStatus[this.summaryStatus]
    }
  },
  methods: {

    formatTranscript(transcript, maxSegmentDuration = 4000) {
      const entries = Object.entries(transcript).map(([time, text]) => ({
        time: parseInt(time, 10),
        speaker: text.split(' : ')[0],
        content: text.split(' : ')[1]
      }))

      const formattedTranscript = []
      let currentSpeaker = null
      let currentContent = []
      let segmentStartTime = null

      entries.forEach((entry, index) => {
        const { time, speaker, content } = entry

        if (speaker !== currentSpeaker) {
          if (currentContent.length > 0) {
            formattedTranscript.push({
              startTime: segmentStartTime,
              endTime: entries[index - 1].time,
              speaker: currentSpeaker,
              content: currentContent.join(' ')
            })
          }
          currentSpeaker = speaker
          currentContent = []
          segmentStartTime = time
        }

        currentContent.push(content)
      })

      if (currentContent.length > 0) {
        formattedTranscript.push({
          startTime: segmentStartTime,
          endTime: entries[entries.length - 1].time,
          speaker: currentSpeaker,
          content: currentContent.join(' ')
        })
      }

      const splitTranscript = []

      formattedTranscript.forEach((segment) => {
        const { startTime, endTime, speaker, content } = segment
        const duration = endTime - startTime

        if (duration > maxSegmentDuration) {
          const words = content.split(' ')
          let chunkStartTime = startTime
          let chunkContent = []

          words.forEach((word, index) => {
            const wordDuration = duration / words.length
            const wordStartTime = startTime + index * wordDuration
            const wordEndTime = wordStartTime + wordDuration

            if (
              wordEndTime - chunkStartTime > maxSegmentDuration &&
          chunkContent.length > 0
            ) {
              splitTranscript.push({
                startTime: chunkStartTime,
                endTime: wordStartTime,
                speaker,
                content: chunkContent.join(' ')
              })
              chunkStartTime = wordStartTime
              chunkContent = []
            }

            chunkContent.push(word)
          })

          if (chunkContent.length > 0) {
            splitTranscript.push({
              startTime: chunkStartTime,
              endTime,
              speaker,
              content: chunkContent.join(' ')
            })
          }
        } else {
          splitTranscript.push(segment)
        }
      })

      return splitTranscript
        .map((segment) => {
          const start = new Date(segment.startTime).toISOString().substr(14, 5)
          const end = new Date(segment.endTime).toISOString().substr(14, 5)
          return `Speaker: ${segment.speaker}\n${start} - ${end} : ${segment.content}`
        })
        .join('\n\n')
    },
    formatTranscriptionInSeconds(jsonData) {
      const transcription =
        typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData

      const formatTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000)
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
          2,
          '0'
        )}`
      }

      const formattedLines = []
      for (const [time, text] of Object.entries(transcription)) {
        // Format the time and add it to the lines
        const formattedTime = formatTime(Number(time))
        formattedLines.push(`${formattedTime}: ${text}`)
      }
      return formattedLines.join('\n')
    },
    /**
     * ONBOARDING MIKROFONU (2026-08-12)
     *
     * Przeglądarka NIE poda identyfikatorów urządzeń, dopóki nie dostanie
     * zgody na mikrofon — enumerateDevices zwraca wtedy wpisy z PUSTYM
     * deviceId. Szablon montuje nagrywarkę tylko gdy selectedMicrophone
     * != '', więc bez zgody okno pokazywało pusty panel i nagrywanie
     * "nie działało", bez jednego komunikatu (catch był wyciszony).
     *
     * Zgoda jest przypisana do ADRESU strony, więc przy przenosinach na
     * nowy host (ehr.gabinet.plus) zgoda z produkcji nie obowiązuje —
     * stąd "na iPadzie działa, na Windowsie nie".
     *
     * Dlatego: przy montowaniu pytamy CICHO (gdy zgoda już jest, lista
     * wypełnia się bez pytania), a o zgodę prosimy dopiero przy OTWARCIU
     * okna nagrywania — patrz watch: open. Po pierwszej zgodzie pamięta
     * ją sama przeglądarka; my nic nie przechowujemy.
     */
    async getMicrophones({ pytajOZgode = false } = {}) {
      try {
        if (pytajOZgode) {
          let probka = null
          try {
            probka = await navigator.mediaDevices.getUserMedia({ audio: true })
          } catch (error) {
            const powod = error && error.name
            this.mikrofonKomunikat =
              powod === 'NotAllowedError' || powod === 'SecurityError'
                ? 'Brak zgody na mikrofon. Kliknij kłódkę przy adresie strony, ustaw Mikrofon na „Zezwalaj" i spróbuj ponownie.'
                : powod === 'NotFoundError'
                  ? 'Nie znaleziono mikrofonu. Podłącz urządzenie i spróbuj ponownie.'
                  : 'Nie udało się uruchomić mikrofonu.'
            return
          } finally {
            // zwalniamy urządzenie — nagrywarka otworzy je sama, z wybranym deviceId
            if (probka) probka.getTracks().forEach((sciezka) => sciezka.stop())
          }
        }
        const devices = await navigator.mediaDevices.enumerateDevices()
        // pusty deviceId = brak zgody; taki wpis jest bezużyteczny i był
        // dokładnie tym, co cicho blokowało montowanie nagrywarki
        this.microphones = devices.filter(
          (device) => device.kind === 'audioinput' && device.deviceId
        )
        if (this.microphones.length > 0) {
          this.selectedMicrophone = this.microphones[0].deviceId
          this.mikrofonKomunikat = ''
        } else if (pytajOZgode) {
          this.mikrofonKomunikat =
            'Nie znaleziono mikrofonu. Sprawdź, czy urządzenie jest podłączone.'
        }
      } catch (error) {
        if (pytajOZgode) {
          this.mikrofonKomunikat = 'Nie udało się odczytać listy mikrofonów.'
        }
      }
    },
    /** Wywoływane przy otwarciu okna: pierwsze otwarcie na urządzeniu pyta o zgodę. */
    async zapewnijMikrofon(wymusPonowienie = false) {
      if (this.selectedMicrophone && !wymusPonowienie) return
      this.mikrofonKomunikat = ''
      await this.getMicrophones({ pytajOZgode: true })
    },
    async processChunks(presignedUrl) {
      const flattened = this.audioChunks.flat()
      const blobData = new Blob(flattened, { type: 'audio/wav' })
      const result = await uploadAudioChunk(blobData, presignedUrl)
      return Promise.resolve(result)
    },
    minimizeCapture() {
      // this.isMinimized
      this.$emit('minimized')
      const el = document.querySelector('#speech-modal___BV_modal_outer_')
      el.style = 'position: absolute; z-index: -1040;'
    },
    stripMarkdown(inputText) {
      let textWithoutHeaders = inputText.replace(/#{1,6}\s/g, '')
      let textWithoutBold = textWithoutHeaders.replace(
        /(\*\*|__)(.*?)\1/g,
        '$2'
      )
      let textWithoutItalic = textWithoutBold.replace(/(\*|_)(.*?)\1/g, '$2')
      let textWithoutStrikethrough = textWithoutItalic.replace(
        /~~(.*?)~~/g,
        '$1'
      )
      let textWithoutUnorderedList = textWithoutStrikethrough.replace(
        /^- (.*)/gm,
        '$1'
      )
      let textWithoutOrderedList = textWithoutUnorderedList.replace(
        /^\d+\.\s(.*)/gm,
        '$1'
      )
      let textWithoutLinks = textWithoutOrderedList.replace(
        /\[([^\]]+)\]\([^)]+\)/g,
        '$1'
      )
      return textWithoutLinks
    },
    cleanAndFormatText(inputText) {
      let formattedText = inputText.replace(/\n/g, '<br>')
      return this.stripMarkdown(formattedText)
      // let formattedText = inputText.replace(/###/g, '<b>')
      // formattedText = formattedText.replace(/####/g, '</b>')

      // return formattedText
    },

    async getPresignedUrl(payload, visitId) {
      const url = `${baseURL}/api/auth/aiservices/${visitId}/presigned-asset-url`
      const headers = {
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
      const response = await fetch(url, {
        headers,
        method: 'POST',
        body: JSON.stringify(payload)
      })
      const result = await response.json()
      return result
    },
    /**
     * Błąd podsumowania (19.10.2026): wcześniej odpowiedź błędu — np. strona „504 Gateway
     * Time-out” z nginx — lądowała w polu podsumowania i „Zapisz” mogło ją wpisać do wizyty.
     * Teraz pole podsumowania zostaje puste, komunikat stoi nad nim, tekst rozmowy zostaje.
     */
    pokazBladPodsumowania(komunikat) {
      if (this.$refs.voiceFormatted) this.$refs.voiceFormatted.innerHTML = ''
      this.summaryError =
        komunikat +
        ' Tekst rozmowy jest zachowany po lewej — możesz spróbować ponownie albo zapisać sam tekst.'
      this.summaryStatus = 0
      this.progressStatus = 0
    },
    async startStreaming(payload, visitId) {
      this.summaryStatus = 1
      this.progressStatus = 0
      this.summaryError = ''
      const url = `${baseURL}/api/auth/aiservices/${visitId}/summarize-with-rt-stream`
      try {
        const headers = {
          Authorization: localStorage.getItem('token'),
          'Content-Type': 'application/json'
        }
        const response = await fetch(url, {
          headers,
          method: 'POST',
          body: JSON.stringify(payload)
        })
        if (!response.ok) {
          let komunikat = ''
          try {
            komunikat = (await response.json()).message || ''
          } catch (e) {
            komunikat = ''
          }
          if (!komunikat) {
            komunikat =
              response.status === 504
                ? 'Usługa podsumowań nie odpowiedziała na czas.'
                : `Nie udało się przygotować podsumowania (błąd ${response.status}).`
          }
          this.pokazBladPodsumowania(komunikat)
          return
        }
        this.updateSummaryProgress(3)
        // Using While Loop
        let summarizedText = ''
        const reader = response?.body?.getReader()
        const decoder = new TextDecoder()
        this.updateSummaryProgress(4)
        while (true) {
          const { done, value: chunk } = await reader.read()
          if (done) break
          const decodedValue = decoder.decode(chunk)

          summarizedText += decodedValue

          this.$refs.voiceFormatted.innerHTML =
            this.cleanAndFormatText(summarizedText)
          this.$refs.scrollableDivFormatted.scrollTop =
            this.$refs.voiceFormatted.scrollHeight
          this.updateSummaryProgress(5)
        }
        this.updateSummaryProgress(6)
        this.summaryStatus = 2
      } catch (error) {
        this.pokazBladPodsumowania('Brak połączenia z serwerem podczas podsumowania.')
      }
    },

    htmlToPlainText(htmlString) {
      const parser = new DOMParser()
      htmlString = htmlString.replace(/<br>/g, '\n')
      const doc = parser.parseFromString(htmlString, 'text/html')
      function extractText(node, resultArray) {
        let consecutiveBrCount = 0

        node.childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE) {
            resultArray.push(child.textContent)
          } else if (child.nodeType === Node.ELEMENT_NODE) {
            if (child.tagName.toLowerCase() === 'br') {
              // Track consecutive <br> tags
              consecutiveBrCount++
            } else {
              // If consecutive <br> tags, add appropriate newline characters
              if (consecutiveBrCount > 0) {
                resultArray.push('\n'.repeat(consecutiveBrCount))
                consecutiveBrCount = 0 // Reset the count
              }
              extractText(child, resultArray)
            }
          }
        })
      }
      const resultArray = []
      extractText(doc.body, resultArray)
      const plainText = resultArray.join('\n')
      return plainText
    },
    handleSave(_e) {
      this.$emit('save-summary', {
        source: this.$refs.voiceSource.innerHTML,
        content: this.$refs.voiceFormatted.innerHTML,
        contentPlain: this.$refs.voiceFormatted.innerText
      })
    },
    handlePromptChange(_e) {
      this.summaryStatus = 0
    },
    async updateSummaryProgress(stepNo) {
      this.progressStatus = stepNo
    },
    async handleSummarize() {
      try {
        this.progressStatus = 0
        const visitId = this.$route.params.visit
        const hashId = nanoid(4)
        const payload = {
          promptId: this.promptId,
          patientId: this.$route.params.id,
          hashId,
          fileInfo: {
            extension: 'wav',
            mimeType: 'audio/wav'
          },
          sourceText: this.sourceContent
        }
        this.summaryStatus = 1
        this.updateSummaryProgress(1)
        //        const signedUrl = await this.getPresignedUrl(payload, visitId)
        //      await this.processChunks(signedUrl.url)
        this.updateSummaryProgress(2)
        return this.startStreaming(payload, visitId)
      } catch (error) {}
    },
    clearAll() {
      this.timelineContent = ''
      this.sourceContent = ''
      this.summaryStatus = 0
      // this.$refs.speechCapt.clearAll()
    },
    async getSummaryPrompts() {
      try {
        const visitId = this.$route.params.visit
        const patientId = this.$route.params.id
        const response = await aiServicesApi.getSummaryPrompts(
          visitId,
          patientId
        )
        // słownik z medapi (19.10.2026); gdy go brak — pusty, żeby przycisk nagrywania nie czekał w nieskończoność
        this.vocabSettings = response?.vocab_settings || { boost_list: [], custom_list: [] }
        return response?.prompts || []
      } catch (e) {
        this.vocabSettings = { boost_list: [], custom_list: [] }
        return []
      }
    },
    async getCaptureTitle() {
      try {
        const visitId = this.$route.params.visit
        const patientId = this.$route.params.id
        const response = await aiServicesApi.getSpeechCaption(
          visitId,
          patientId
        )
        return response.title
      } catch (e) {}
    },
    onTranscription(dataChunks) {
      this.audioChunks = dataChunks
    },

    onStopped() {
      this.finalTranscript = this.sourceContent
    },
    onTranscriptionText(transcriptList) {
    //  const formatted = this.formatTranscriptionInSeconds(transcriptText)
      const tscriptList = JSON.parse(transcriptList)
      // const tscript = tscriptList.map((segment) => {
      //   const start = new Date(segment.startTime * 1000).toISOString().substr(11, 8)
      //   //const end = new Date(segment.endTime * 1000).toISOString().substr(11, 8)
      //   return `${start} - ${end} : Speaker : ${segment.speaker} : "${segment.content}"`
      // })
      //   .join('\n')
      // const formattedLines = []
      const defaultFormatList = {}
      for (const [t, info] of Object.entries(tscriptList)) {
        // Format the time and add it to the lines
        // const formattedTime = formatTime(Number(time))
        defaultFormatList[t] = `${info.s} : ${info.c}`
        // formattedLines.push(`${t}: ${info.s} : ${info.c}`)
      }
      // console.log(defaultFormatList)
      const formatted = this.formatTranscript(defaultFormatList)
      this.sourceContent = this.cleanAndFormatText(formatted)// formatted.join('<br>')// this.cleanAndFormatText(formatted)
      this.finalTranscript = this.sourceContent
      // this.$refs.voiceSource.innerHTML = formatted
    },
    onSessionInitiated({ sessionId }) {
      this.recordingStartedAt = Date.now()
      const visitId = this.$route.params.visit
      const patientId = this.$route.params.id
      let payload = { url: location.href, visitId, patientId, eventType: 'ai-vs-init', sessionId }
      aiServicesApi.logEvent(payload)
      this.uruchomAutozapis(sessionId)
    },
    // co 60 s dotychczasowy tekst do dziennika w medapi (jeden wiersz na sesję, nadpisywany); tylko gdy tekst się zmienił
    uruchomAutozapis(sessionId) {
      this.zatrzymajAutozapis()
      this.autozapisSesja = sessionId || 'bez-sesji-' + Date.now()
      this.autozapisOstatni = ''
      this.autozapisTimer = setInterval(() => {
        const tekst = (this.sourceContent || '').replace(/<br>/g, '\n')
        if (!tekst.trim() || tekst === this.autozapisOstatni) return
        this.autozapisOstatni = tekst
        aiServicesApi.logEvent({
          visitId: this.$route.params.visit,
          patientId: this.$route.params.id,
          eventType: 'ai-vs-autosave',
          sessionId: this.autozapisSesja,
          transcript: tekst
        })
      }, 60000)
    },
    zatrzymajAutozapis() {
      if (this.autozapisTimer) clearInterval(this.autozapisTimer)
      this.autozapisTimer = null
    },
    przywrocZapisana() {
      const z = this.zapisane[0]
      if (!z?.tresc) return
      const bezpieczny = String(z.tresc).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      this.sourceContent = bezpieczny.replace(/\n/g, '<br>')
      this.finalTranscript = this.sourceContent
      this.summaryError = ''
    },
    onSessionInitiationError(errorText) {
      const visitId = this.$route.params.visit
      const patientId = this.$route.params.id
      let payload = { url: location.href, visitId, patientId, eventType: 'ai-vs-error', errorMessage: errorText }
      aiServicesApi.logEvent(payload)
    },
    onSessionCompleted({ sessionId, text }) {
      this.recordingStartedAt = null
      this.zatrzymajAutozapis()
      // const formatted = this.formatTranscriptionInSeconds(text)
      // const finalText = this.cleanAndFormatText(formatted)
      const defaultFormatList = {}
      for (const [t, info] of Object.entries(text)) {
        // Format the time and add it to the lines
        // const formattedTime = formatTime(Number(time))
        defaultFormatList[t] = `${info.s} : ${info.c}`
        // formattedLines.push(`${t}: ${info.s} : ${info.c}`)
      }
      // console.log(defaultFormatList)
      const formatted = this.formatTranscript(defaultFormatList)
      const finalText = this.cleanAndFormatText(formatted)
      const visitId = this.$route.params.visit
      const patientId = this.$route.params.id
      let payload = { url: location.href, visitId, patientId, eventType: 'ai-vs-stop', sessionId: sessionId || this.autozapisSesja, transcript: finalText?.replace(/<br>/g, '\n') }
      aiServicesApi.logEvent(payload)
      // nowy zapis od razu widoczny w linku „Przywróć”, gdyby lekarz wyczyścił pole przed podsumowaniem
      // (serwer EHR odpowiada przed zapisem w medapi — stąd zwłoka)
      setTimeout(() => aiServicesApi.getSavedTranscripts(visitId).then((lista) => { this.zapisane = lista }), 5000)
    }
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    // telewizyta: dźwięk rozmowy telefonicznej; pojawia się = transkrypcja startuje sama,
    // znika (rozłączenie) = transkrypcja staje, a podsumowanie robi się jak po wizycie w gabinecie
    externalStream: {
      default: null
    }
  },
  watch: {
    async externalStream(nowy, stary) {
      if (nowy) this.telewizytaAktywna = true
      // komponent nagrywania powstaje po wczytaniu ustawień słownika (przy telewizycie bez
      // wyboru mikrofonu — na nowym komputerze bez zgody lista mikrofonów jest pusta) — czekamy do 30 s
      let mic = this.$refs.speechCapt
      for (let i = 0; !mic && i < 60; i++) {
        await new Promise((resolve) => setTimeout(resolve, 500))
        mic = this.$refs.speechCapt
      }
      if (!mic) return
      if (nowy && !stary && !mic.isRecording) await mic.toggleRecording()
      if (!nowy && stary && mic.isRecording) await mic.toggleRecording()
    },
    // immediate, bo rodzic remontuje komponent (:key=componentKey) i tworzy
    // go od razu z open=true — zwykły watcher by wtedy nie zadziałał
    open: {
      immediate: true,
      handler(otwarte) {
        if (otwarte) this.zapewnijMikrofon()
      }
    }
  }
}
</script>
<style>
/* Additional styling for editable content */
.editable-content {
  border: 0px solid #ddd;
  /* Add a border for visual separation */
  padding: 1px;
  min-height: 200px;
  margin: 0 !important;
  width: 100%;

  /* Set a minimum height for better visibility */
}

.words {
  max-width: 500px;
  margin: 1px auto;
  color: darkblue;
  background-color: white;
  border-radius: 2px;
  box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.1);
  padding: 1rem 2rem 1rem 1.2rem;
  background: -webkit-gradient(
      linear,
      0 0,
      0 100%,
      from(#d9eaf3),
      color-stop(4%, #fff)
    )
    0 4px;
  background-size: 100% 1.5rem;
  position: relative;
  line-height: 1.5rem;
  margin: 0 0 1rem;
  font-family: 'Georgia', serif;
}

p {
  margin: 0 0 1rem;
  font-family: 'Georgia', serif;
}

.words:before {
  content: '';
  position: absolute;
  width: 4px;
  top: 0;
  left: 1px;
  bottom: 0;
  border: 1px solid;
  border-color: transparent #efe4e4;
}

.voiceCapture .card-body {
  padding: 0.25rem !important;
  margin-left: 0.1rem;
}
</style>
